import { render, staticRenderFns } from "./AscAirlineMgmtTemplate.vue?vue&type=template&id=600f8070&"
import script from "./AscAirlineMgmtTemplate.vue?vue&type=script&lang=js&"
export * from "./AscAirlineMgmtTemplate.vue?vue&type=script&lang=js&"
import style0 from "./AscAirlineMgmtTemplate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports